/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import {search} from '../../utils/utils'

const getters = {
    users: state => state.users,
    usersFiltered: (state) => {
        return (filter) => {
            for (const obj in filter) {
                if (filter[obj] === null) {
                    delete filter[obj]
                }
            }
            return search(state.users, filter)
        }
    }
}

export default getters
